import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import PETROLSIDE from "../../../assets/png/ENGINEERING.jpg";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import NZElectricaATV from "../../../components/NZComponent/NzElectricAccessories/NZElectricaATV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZElectricGregFarrier from "../../../components/NZComponent/home/NZElectricGregFarrier/NZElectricGregFarrier";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NZElectricFeatures from "../../../components/NZComponent/NzElectricAccessories/NZElectricFeatures";
import NZElectricModels from "../../../components/NZComponent/NzElectricAccessories/NZElectricModels";
import NZElectricSafety from "../../../components/NZComponent/NzElectricAccessories/NZElectricSafety";
import NZElectricSpec from "../../../components/NZComponent/NzElectricAccessories/NZElectricSpec";

const NzElectricAccessories = () => {
  let navigate = useNavigate();
  return (
    <>
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img src={HomeIcon} alt="HomeIcon" className="cursor-pointer" onClick={() => navigate("/")} />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Electric`}</div>
        </div>
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-[50px]">
          <div className="h-[400px] md:h-[720px] w-full">
            <div
              className="h-[400px] w-full md:h-full"
              style={{
                backgroundImage: `url(${PETROLSIDE})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
          </div>
          <div className="p-[50px] md:pt-[100px] py-[20px]">
            <div
              className="text-white kuunari-bold 
              text-[20px] 
              md:text-[40px] 
              lg:text-[60px]  
              leading-[32px]
              md:leading-[42px] 
              lg:leading-[62px]
              mb-[11px] 
              text-center 
              max-w-[511px] 
              mx-auto"
              style={{
                textShadow: "2px 4px 6px #000000",
              }}
            >
              eTUATARA 1500E
            </div>
            <p className="text-[#666666] md:text-[20px] text-[16px] leading-[26px] text-center montserrat-medium">
              The eTuatara is well suited to the farm environment given that it is very cheap to operate and maintain
              and can be charged at night. It has the added advantage over its combustion engine counterparts of
              developing full torque at any speed while a combustion engine may only develop full torque at 5000 rpm for
              example. This makes the eTuatara ideal for traversing steep inclines or for towing, but the greatest
              feature of the eTuatata is its versatility. This vehicle can be used for farming, horticulture,
              beekeeping, and even not non-agriculture activities, such as golf courses, retirement villages, forestry,
              parks, large gardens, airports, power stations and the list goes on.
            </p>
            {/* <br />
            <p className="text-[#666666] md:text-[20px] text-[16px] leading-[26px] text-center montserrat-medium">
              The cargo carrying and towing capacity, low running costs and simplicity make this highly versatile
              machine ideal for tackling your daily tasks. The eTuatara is designed to meet lifesyle, agricultural or
              commercial needs with a much smaller footprint than a conventional utility vehicle.
            </p> */}
          </div>
        </div>

        <div>
          <NZElectricFeatures />
          <NZElectricModels />
          <NZElectricSafety />
          <NZElectricSpec />
          {/* <NZElectricaATV /> */}
          {/* <NZElectricGregFarrier />
          <NZElectricaTV /> */}
        </div>
        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzElectricAccessories;
